module.exports = __webpack_public_path__ + "media/images/flags/1x1/gab-4a6859bc85a0c7ebeee296f78e321652.svg";